<div class="pades-signature-image-choice-modal">
  <div class="modal-header">
    <h3 class="modal-title" tabindex="-1" cdkFocusInitial>Imagen de firma</h3>
    <button class="btn-close" (click)="cancel()" type="button" aria-label="Cerrar">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <p class="modal-subtitle">¿Usar firma visible  o subir su propia imagen?</p>
    <div class="choice-actions">
      <button class="btn-choice" type="button" (click)="useDefault()">
        <i class="fas fa-stamp"></i>
        Dibujar firma
      </button>
      <div class="upload-section">
        <input #fileInput type="file" accept=".png,.jpg,.jpeg" (change)="onFileSelected($event)" hidden />
        <button class="btn-choice" type="button" (click)="triggerFileInput()">
          <i class="fas fa-image"></i>
          Subir mi imagen (PNG/JPG)
        </button>
        <p class="file-name" *ngIf="selectedFile">{{ selectedFile.name }}</p>
        <p class="error-msg" *ngIf="errorMessage">{{ errorMessage }}</p>
        <button class="btn-confirm-upload" type="button" (click)="confirmUpload()" [disabled]="!selectedFile">
          Usar esta imagen
        </button>
      </div>
    </div>
  </div>
  <div class="modal-actions">
    <button class="btn-secondary" type="button" (click)="cancel()">Cancelar</button>
  </div>
</div>
